import utilMixin from "./mixins";
import applicationMixin from "./application-mixin";
import {Document} from '../entities';
import * as types from "../stores/constants";
import {mapActions, mapState} from "pinia";
import {defaultCountry} from "../entities/default";
import useApplicationStore from "../stores/application_module";
import useModuleStore from "../stores";

const DOCUMENT_ENTITY_CODE_PRINCIPAL = 'PRINCIPAL';
const DOCUMENT_ENTITY_CODE_BUSINESS = 'BUSINESS';
const DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT = 'BUSINESS_CONTACT';
const DOCUMENT_ENTITY_CODE_BUSINESS_BANK = 'BUSINESS_BANK';
const DOCUMENT_CATEGORY_REQUIRED_NO = '0';
const DOCUMENT_CATEGORY_REQUIRED_YES = '1';
const DOCUMENT_CATEGORY_REQUIRED_CONDITIONAL= '2';

const DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_BUSINESS_TYPE = 'BUSINESS_TYPE';
const DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_NO_BANK_ID = 'NO_BANK_ID';
const DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_EKYC = 'E_KYC';
const DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_NO_ID_PAL = 'NO_ID_PAL';

const WORKFLOW_PROCESS_ACTION_EKYC = 'EKYC';
const WORKFLOW_PROCESS_ACTION_IDPAL = 'IDPAL';
const WORKFLOW_PROCESS_ACTION_APPLICATION_DOCUMENTS = 'APPLICATION_DOCUMENTS';

const UPLOAD_DOCUMENT_CATEGORY_PARAM = 'UPLOAD_DOCUMENT_CATEGORY_PARAM';

class DocumentCategoryValidationSet {
    constructor(item) {
        this.minimum = '';
        this.unique = false;
        this.count = 0;
        this.message_key = '';
        this.catalogue = [];

        if (!!item) {
            this.setItem(item);
        }
    }

    setItem(item) {
        let item_keys = Object.keys(item);
        item_keys.map(f => {
            this[f] = item[f]
        });
    }
}

export default {
    mixins: [utilMixin, applicationMixin],
    data (){
        return {
            document: new Document(),
            files: [],
            document_entities_map: [],
            //documents: [],
            document_categories: [],
            document_entities: [],
            signed_reference: '12345676543',
            page_label: 'upload_your_supporting_documents',
            signed_label: 'supporting_documents_uploaded',
            abortRouteLeave: false,
            document_categories_validation_rules: {
                // 'PROOF_OF_ID' : {
                //     minimum: 1,
                //     unique: true,
                //     count: 0,
                //     catalogue:[]
                // },
                // 'PROOF_OF_ADDRESS' : {
                //     minimum: 1,
                //     unique: false,
                //     count: 0,
                //     catalogue:[]
                // },
                // 'PROOF_OF_BANK' : {
                //     minimum: 1,
                //     unique: false,
                //     count: 0,
                //     catalogue:[]
                // },
                // 'PROOF_OF_BUSINESS' : {
                //     minimum: 1,
                //     unique: false,
                //     count: 0,
                //     catalogue:[]
                // },
            },
            document_category_validation_message_key: {
                PROOF_OF_ID : {
                    notice_key: 'proof_of_id_notice',
                    error_key: '',
                    success_key: '',
                },
                PROOF_OF_ADDRESS : {
                    notice_key: 'proof_of_address_notice',
                    error_key: '',
                    success_key: '',
                },
                APPLICATION_DOCUMENTS : {
                    notice_key: 'application_documents_notice',
                    error_key: '',
                    success_key: '',
                },
                PROOF_OF_BANK : {
                    notice_key: 'proof_of_bank_notice',
                    error_key: '',
                    success_key: '',
                },
                PROOF_OF_BUSINESS : {
                    notice_key: 'proof_of_business_notice',
                    error_key: '',
                    success_key: '',
                },
                OTHER : {
                    notice_key: 'proof_of_other_notice',
                    error_key: '',
                    success_key: '',
                },
            },
            time_dilation: {
                getDocumentCategoryMessage:null
            },
            optional_document_categories: {},
            ekyc_verification: 0,
            category_has_document_entity: [],
            document_categories_required: 0,
            show_idpal_section: false,
            all_signatories_validated: true,
            signatories_validated_has_error_message: false,
            signatories_upload_documents_flag: 0,
            signatory_has_upload_documents: false,
            id_pal_key: '0',
        }
    },
    computed: {
        ...mapState(useApplicationStore, {documents:'documents', loading_document_upload:'loading_document_upload'}),
        tenantUploadCategories: function () {
            let params = (!!this.parameters && this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'))?
                this.parameters['TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            return params.map(obj => new Document(obj))
        },
        isUploading: function () {
            if (!!this.$refs[`uploader_${document.id}`]) {
                this.$refs[`uploader_${document.id}`].uploadStatus();
            }
            return false;
        },
        noDocumentSelected: function () {
            return !(this.document_categories.find((category) => category.selected == '1'));
        },
        hasUploadedFiles: function () {
            const found = Array.isArray(this.documents) && this.documents.find(doc => doc.selected == '1' && doc.uploaded_files.length > 0);
            //console.log('found', found);
            return !!found;
        },
        hasUploadedRequiredFiles: function () {
            let upload_categories = this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];

            for(const [category_code, validation_rules] of Object.entries(this.document_categories_validation_rules)) {

                let document_category_external_id = upload_categories.find(upload_category => {
                    return (upload_category.hasOwnProperty('category_code') &&
                            upload_category.category_code == category_code);
                }, category_code)['document_category_external_id'];

                const found = this.documents.find((doc) => {
                    return (doc.selected == '1' && doc.uploaded_files.length > 0 &&
                            doc.document_category_external_id === document_category_external_id);
                });

                if (!found) {
                    return false;
                }
            }
            return true;
        },
        parDocumentCategories: function () {
            let has_categories = this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM');
            return has_categories ? this.parameters[UPLOAD_DOCUMENT_CATEGORY_PARAM] : [];
        },
        requiredDocs: function () {
            let vm = this;
            this.initDocumentValidationRulesByConfig()
            const required_docs = {
                'PROOF_OF_ID': 'proof_of_id',
                'PROOF_OF_ADDRESS': 'proof_of_address',
                'PROOF_OF_BANK': 'proof_of_bank',
                'PROOF_OF_BUSINESS': 'proof_of_business',
                'APPLICATION_DOCUMENTS': 'application_documents',
                'OTHER': 'proof_of_other',
            };
            let response = {}

            if(this.document_categories.length > 0 && this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM'))
            {
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'].forEach(obj => {
                    let id = obj.category_code
                    let check = Object.keys(vm.document_categories_validation_rules).find(element => element === id)
                    if (check){
                        if(required_docs.hasOwnProperty(obj['category_code']))
                        {
                            response[obj['category_code']] = required_docs[obj['category_code']]
                        }
                    }
                })
            }
            else
            {
                response = required_docs
            }

            return response
        },
        // orderedDocumentCategories: function() {
        //     let vm = this;
        //     console.log('doc Cat Payload', vm.document_categories);
        //
        //     if (this.timerExpired('orderedDocumentCategories')) {
        //         this.initDocumentValidationRulesByConfig();
        //     }
        //
        //     let listed_tenant_category_external_ids = vm.document_categories.map(category => {
        //         return category.tenant_udc_external_id
        //     });
        //
        //     let has_priority_order_at_tenant_level = vm.tenantUploadCategories.some(tenant_category => {
        //         let is_listed_tenant_category = listed_tenant_category_external_ids.includes(
        //             tenant_category.tenant_udc_external_id);
        //
        //         let has_priority = tenant_category.hasOwnProperty('priority_order') &&
        //             parseInt(tenant_category.priority_order) > 0;
        //
        //         return is_listed_tenant_category && has_priority;
        //     });
        //
        //     console.log('has_priority_order_at_tenant_level', has_priority_order_at_tenant_level);
        //
        //     let document_categories_with_priority_order_field = has_priority_order_at_tenant_level ?
        //         vm.document_categories.map(category => {
        //             let tenantCategory = vm.tenantUploadCategories.find(tenant_category => {
        //                 return tenant_category.tenant_udc_external_id === category.tenant_udc_external_id;
        //             });
        //
        //             // console.log('tenantCategory => ', tenantCategory);
        //             let priority_order = tenantCategory.hasOwnProperty('priority_order') ?
        //                 tenantCategory.priority_order :
        //                 category.hasOwnProperty('priority_order') ? category.priority_order : 0;
        //
        //             return {
        //                 ...category,
        //                 priority_order: priority_order
        //             }
        //         }) : vm.document_categories;
        //
        //     //updating the requirementState
        //     document_categories_with_priority_order_field =
        //         document_categories_with_priority_order_field.map(categoryObj => {
        //             let validation_rules = vm.document_categories_validation_rules;
        //             return {
        //                 ...categoryObj,
        //                 requiredState: validation_rules && categoryObj.category_code &&
        //                 Object.keys(validation_rules).includes(categoryObj.category_code) ?
        //                     'M' : 'O',
        //             }
        //         });
        //
        //     document_categories_with_priority_order_field.sort((a,b) => vm.orderByPriorityOrder(a,b));
        //
        //     console.log('doc Cat Payload Updated', document_categories_with_priority_order_field);
        //     return document_categories_with_priority_order_field;
        // },
        requireDocumentsMessage: function() {
            this.initDocumentValidationRulesByConfig()
            let message = '<strong>' + this.lang('document_upload_help_prefix') + '</strong><br>'
            let has_document = false;


            for (const [category_code, validation_payload] of Object.entries(this.document_categories_validation_rules)) {
                has_document = true;
                message = message + this.lang(validation_payload.message_key) +
                    this.lang('minimum_number') + validation_payload.minimum + '<br>'
            }

            //if there are no documents in this section don't pass any message
            return !!has_document ? message : '';
        },
        optionalDocumentsMessage: function () {
            let message = '<strong>' + this.lang('document_upload_optional_help_prefix') + '</strong><br>'
            let has_document = false;

            for (const [category_code, validation_payload] of Object.entries(this.document_category_validation_message_key)) {
                //check that the document is not in the required section
                //for some reason, this.optional_document_categories is not working in the for statement
                if (!this.document_categories_validation_rules.hasOwnProperty(category_code) && category_code !== 'OTHER') {
                    has_document = true;
                    message = message + this.lang(validation_payload.notice_key) + '<br>'
                }
            }

            //if there are no documents in this section don't pass any message
            return !!has_document ? message : '';
        },
        uploadedDocuments: function () {
            let vm = this;
            let upload_categories = (!!this.parameters && this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            let has_upload_categories = upload_categories.length > 0

            //let documents =
            return this.documents.filter(doc => {
                let category_code = has_upload_categories ?
                    upload_categories.find(category => {
                        return category.document_category_external_id === doc.document_category_external_id
                    })['category_code']
                    : undefined;

                return category_code && doc.hasOwnProperty('selected') &&
                    Object.keys(vm.requiredDocs).includes(category_code) &&
                    doc.selected === '1';
            })
        },
        listRequireDocuments: function() {
            this.initDocumentValidationRulesByConfig()
            let message = [];

            for (const [category_code, validation_payload] of Object.entries(this.document_categories_validation_rules)) {
                message.push(this.lang(validation_payload.message_key));
            }
            return message;
        },
        ekycAllowedByWorkflow: function () {
            let vm = this;
            let has_ekyc_workflow = vm.parameters && vm.parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK')
                && vm.parameters['APPLICATION_PROCESS_ACTIONS_CHECK'].hasOwnProperty(WORKFLOW_PROCESS_ACTION_EKYC);
            return has_ekyc_workflow ?
                vm.parameters['APPLICATION_PROCESS_ACTIONS_CHECK'][WORKFLOW_PROCESS_ACTION_EKYC] : false;
        },
        isIdPalWorkflowConfigured: function (){
            return this.isWorkflowActionAllowed(WORKFLOW_PROCESS_ACTION_IDPAL);
        },
        isDocumentUploadWorkflowConfigured: function (){
            return this.isWorkflowActionAllowed(WORKFLOW_PROCESS_ACTION_APPLICATION_DOCUMENTS);
        },
        signerOwner: function () {
            let vm = this;
            let has_signer = vm.merchant && vm.merchant.hasOwnProperty('owners') && vm.merchant.owners.some(owner => {
                return owner.hasOwnProperty('is_signatory') && owner.is_signatory === '1' && !!vm.user.email && owner.owner_email === vm.user.email;
            });
            return has_signer ? vm.merchant.owners.find(owner => {
                return !!owner.owner_email && !!vm.user.email && owner.owner_email === vm.user.email &&
                        owner.hasOwnProperty('is_signatory') && owner.is_signatory === '1';
            }) : {};
        },
        ekycVerificationMessage: function () {
            return parseInt(this.ekyc_verification) === 1 ?
                this.lang('notice_ekyc_verification_yes') : this.lang('notice_ekyc_verification_no');
        },
        hasAllDocumentCategoriesRequired: function () {
            let vm = this;
            return (Array.isArray(vm.document_categories) && vm.document_categories.length > 0 && vm.document_categories.length === vm.document_categories_required);
        },
        mainMerchantUser: function() {
            let main_merchant_user = this.merchant.business_contacts.find(obj => obj.contact_type === 'RACI');
            if (!!main_merchant_user && !!main_merchant_user.business_contact_email) {
                main_merchant_user.email = main_merchant_user.business_contact_email;
            }
            return main_merchant_user;
        },
        getSignerUploadDocumentCategory: function () {
            let vm = this;

            let signer_required_upload_category = null;
            if (vm.isSignerUser) {
                let tenant_upload_document_categories = this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                    this.parameters.TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM : [];

                let upload_document_categories = this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                    this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];

                let signer_required_document_categories = (tenant_upload_document_categories.length > 0)
                    ? tenant_upload_document_categories.filter(tenant_upload_category => {
                        return tenant_upload_category.is_signers_required_document_category === '1';
                    }) : null

                signer_required_upload_category = (upload_document_categories && upload_document_categories.length)
                    ? upload_document_categories.filter((upload_document_category) => {
                        let signer_req_doc_cat = (signer_required_document_categories && signer_required_document_categories.length)
                            ? signer_required_document_categories.find((signer_required_doc_category) => {
                                return upload_document_category.document_category_external_id === signer_required_doc_category.document_category_external_id
                            }) : null;
                        return !!signer_req_doc_cat;
                    }) : null;
            }
            return signer_required_upload_category;
        },
        showEditDocumentSignatory: function () {
            let vm = this;
            return (vm.isSignerUser && vm.signerCanSign && !vm.signerHaveSigned && vm.isAwaitingSignature);
        },
        signerCanSign: function () {
            let owner = null;
            // get user using matching email
            if (!!this.merchant.owners && this.merchant.owners.length > 0) {
                owner = this.merchant.owners.find(owner => {
                    return owner.is_signatory == '1' && owner.owner_email == this.user.email
                });
            }
            return !!owner;
        },
        signerHaveSigned: function () {
            let owner = null;
            // get user using matching email
            if (!!this.merchant.owners && this.merchant.owners.length > 0) {
                let owner = this.merchant.owners.find(owner => {
                    return owner.is_signatory == '1' && owner.owner_email == this.user.email && owner.signer_signed == '1';
                });
                return !!owner;
            }
            return !!owner;
        },
        signerToProvideIdProof: function () {
            let vm = this;
            let result = false;
            if (vm.isSignerUser && !!vm.signerOwner && vm.merchant.signatories_upload_documents_flag == '1') {
                const have_to_upload_required_document = vm.signerToUploadRequiredDocument;
                const has_ekyc_set = (vm.ekycAllowedByWorkflow && vm.signerOwner.ekyc_verification == '1');
                const has_idpal_set = (vm.isIdPalWorkflowConfigured && vm.signerOwner.idpal_verification == '1');

                if (have_to_upload_required_document && !has_ekyc_set && !has_idpal_set) {
                    result = true;
                }
            }
            return result;
        },
        signerHasSignedApplication: function () {
            let vm = this;
            if (vm.isSignerUser && !!vm.signerOwner && !!vm.signerOwner.signer_signed) {
                return vm.signerOwner.signer_signed;
            }
            return false;
        },
        signerToUploadRequiredDocument: function () {
            let vm = this;

            let signatory_to_upload_required_documents = false;
            if (vm.isSignerUser && vm.objectIsNotEmpty(vm.signerOwner)) {
                let signer_required_upload_category = vm.getSignerUploadDocumentCategory;
                let identifiedSignatory = !!vm.documents ? vm.documents.filter(doc => {
                    let doc_cat = !!signer_required_upload_category ? signer_required_upload_category.find((signer_up_doc_cat) => {
                        if (!!doc.document_category_external_id && !!signer_up_doc_cat.document_category_external_id &&
                            doc.document_category_external_id == signer_up_doc_cat.document_category_external_id) {
                            return signer_up_doc_cat;
                        }
                    }) : null;

                    const is_document_selected = doc.selected == '1';
                    const is_document_for_logged_signer = doc.selected_entity_id === vm.signerOwner.owner_ref;
                    const is_document_required_for_signer = !!doc_cat && doc_cat.document_category_external_id == doc.document_category_external_id;

                    if (is_document_selected && is_document_for_logged_signer && is_document_required_for_signer) {
                        return doc;
                    }
                }) : null;

                if (Array.isArray(identifiedSignatory) && identifiedSignatory.length === 0 && Array.isArray(signer_required_upload_category) && signer_required_upload_category.length > 0) {
                    signatory_to_upload_required_documents = true;
                } else if (Array.isArray(identifiedSignatory) && identifiedSignatory.length > 0 && Array.isArray(signer_required_upload_category) &&
                    signer_required_upload_category.length > 0 && identifiedSignatory.length !== signer_required_upload_category.length) {
                    signatory_to_upload_required_documents = true;
                } else if (Array.isArray(identifiedSignatory) && identifiedSignatory.length > 0 && !vm.documentsHaveUploadedFiles(identifiedSignatory)) {
                    signatory_to_upload_required_documents = true;
                }
            }
            return signatory_to_upload_required_documents;
        },
    },
    methods: {
        ...mapActions(useApplicationStore, [types.SET_DOCUMENTS_INSTANCE]),
        setSignatoryProofOfIdDocumentToUpload: function () {
            let vm = this;
            if (vm.isSignerUser && !!vm.signerOwner && vm.signerOwner.hasOwnProperty('owner_ref') && !!vm.signerOwner.owner_ref) {
                let document = !!vm.documents ? vm.documents.find(doc => {
                    // check if any selected proof of id document is assigned to signatory
                    const upload_category = (vm.parameters && vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')) ? vm.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                        return obj.document_category_external_id === doc.document_category_external_id;
                    }) : [];
                    return upload_category.hasOwnProperty('category_code') && upload_category.category_code == 'PROOF_OF_ID';
                }) : null;

                if (!!document && vm.signerToUploadProofOfID) {
                    const existing_docs = vm.documents.filter(doc => doc.id === document.id && doc.selected_entity_id === vm.signerOwner.owner_ref);
                    if (existing_docs.length < 1) {
                    let cloned_doc = JSON.parse(JSON.stringify(document));
                    cloned_doc.selected ='1';
                    cloned_doc.selected_entity_id = vm.signerOwner.owner_ref;
                    cloned_doc.document_external_id = '';
                    cloned_doc.uploaded_files = [];
                    cloned_doc.values.map(value => {
                        if (value.attribute.type == 'country_param') {
                            value.field_value = vm.getAllianceCountryCode();
                        } else {
                            value.field_value = '';
                        }
                    });
                    delete cloned_doc.entity;
                    vm.documents.push(new Document(cloned_doc));
                    }
                }
            }
        },
        setDocumentToUploadForAdditionalSignatory: function (document_param, category) {
            let vm = this;
            if (vm.isSignerUser && vm.objectIsNotEmpty(vm.signerOwner) && vm.signerOwner.hasOwnProperty('owner_ref') && !!vm.signerOwner.owner_ref) {
                // let document = !!vm.documents ? vm.documents.find(doc => {
                    // check if any selected proof of id document is assigned to signatory
                    // const upload_category = vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM') ? vm.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                    //     return obj.document_category_external_id === doc.document_category_external_id;
                    // }) : [];
                    // return upload_category.hasOwnProperty('category_code') && upload_category.category_code == 'PROOF_OF_ID';

                    let signer_upload_document_category = vm.getSignerUploadDocumentCategory;

                    let doc_cat = !!signer_upload_document_category ? signer_upload_document_category.find((signer_up_doc_cat) => {
                        if (!!category.id && !!signer_up_doc_cat.document_category_external_id && category.id === signer_up_doc_cat.document_category_external_id) {
                            return signer_up_doc_cat;
                        }
                    }) : null;

                    let document = null;
                    // if (document_param.document_category_external_id == category.id && !!doc_cat && doc_cat.document_category_external_id == doc.document_category_external_id) {
                    if (!!doc_cat && doc_cat.document_category_external_id == document_param.document_category_external_id) {
                        // return doc;
                        document = document_param;
                    }
                // }) : null;

                if (!!document) {
                    const existing_docs = vm.documents.filter(doc => doc.id === document.id && doc.selected_entity_id === vm.signerOwner.owner_ref);
                    if (existing_docs.length < 1) {
                        let cloned_doc = JSON.parse(JSON.stringify(document));
                        cloned_doc.selected ='1';
                        cloned_doc.selected_entity_id = vm.signerOwner.owner_ref;
                        cloned_doc.document_external_id = '';
                        cloned_doc.uploaded_files = [];
                        cloned_doc.values.map(value => {
                            if (value.attribute.type == 'country_param') {
                                value.field_value = vm.getAllianceCountryCode();
                            } else {
                                value.field_value = '';
                            }
                        });
                        delete cloned_doc.entity;
                        vm.documents.push(new Document(cloned_doc));
                    }
                }
            }
        },
        documentsHaveUploadedFiles: function (documents) {
            const found = Array.isArray(documents) && documents.find(doc => doc.uploaded_files.length > 0);
            return !!found;
        },
        signerToUploadProofOfID: function () {
            let vm = this;
            const signatories = (!!vm.merchant && vm.merchant.hasOwnProperty('owners')) ? vm.merchant.owners.filter((owner) => {
                return owner.is_signatory == '1' && owner.owner_email == vm.user.email && vm.isSignerUser;
            }) : [];
            let all_signatories_validated = false;
            if (signatories.length) {
                signatories.forEach(signatory => {
                    const identifiedSignatory = !!this.documents ? this.documents.find(doc => {
                        // check if any selected proof of id document is assigned to signatory
                        const upload_category = vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')
                            ? this.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                                return obj.document_category_external_id === doc.document_category_external_id;
                            }) : [];
                        return doc.selected == '1' && upload_category.hasOwnProperty('category_code') &&
                            upload_category.category_code == 'PROOF_OF_ID' &&
                            doc.selected_entity_id == signatory.owner_ref && signatory.owner_email == vm.user.email;
                    }) : null;
                    if (!identifiedSignatory && vm.isSignerUser) {
                        if (vm.merchant.signatories_upload_documents_flag === '1') {
                            all_signatories_validated = true;
                        }
                    } else {
                        all_signatories_validated = false;
                    }
                });
            }
            return all_signatories_validated;
        },
        setShowIdPalSection: function (){
            //TODO fix this
            this.show_idpal_section = false;

            if (this.isIdPalWorkflowConfigured) {
                //show when
                //1. idpal is selected by signer
                //2. idpal is not selected (can be 0 or "") and no documents have been upload.
                let hasDoneIdPal = !!(this.signerOwner && this.signerOwner.hasOwnProperty('idpal_verification') &&
                    this.signerOwner.idpal_verification && this.signerOwner.hasOwnProperty('idpal_uuid') &&
                    this.signerOwner.idpal_uuid)

                //TODO needs rework on the first step.
                if (hasDoneIdPal) {
                    this.show_idpal_section = true;
                } else if (this.signerOwner && (!this.signerOwner.hasOwnProperty('idpal_verification') || this.signerOwner.idpal_verification == '0')) {
                    this.show_idpal_section = false;
                } else {
                    let has_uploaded_doc_file = this.hasUploadedFiles;
                    if (this.isSignerUser) {
                        has_uploaded_doc_file = this.signerHasUploadedFiles();
                    }
                    this.show_idpal_section = hasDoneIdPal || (!hasDoneIdPal && !has_uploaded_doc_file)
                }
            }
        },
        alertSwitchToIdPal: function (){
            let vm = this;
          //TODO show pop up,
            let has_uploaded_doc_file = vm.hasUploadedFiles;
            if (vm.isSignerUser) {
                has_uploaded_doc_file = vm.signerHasUploadedFiles();
            }
            if (has_uploaded_doc_file){ //only show pop up if they have uploaded documents
                this.$swal({
                    title: this.lang('are_you_sure'),
                    text: this.lang('once_changed_you_will_lose_the_previously_uploaded_documents'),
                    icon: "warning",
                    confirmButtonColor: '#e64942',
                    showCancelButton: true,
                    confirmButtonText: this.lang('ok'),
                    cancelButtonText:this.lang('cancel'),
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    },
                    dangerMode: true,
                }).then( selected_option => {
                    if (selected_option){
                        vm.show_idpal_section = true;
                    }
                })
            }else{
                vm.show_idpal_section = true;
            }
        },
        updateMerchantIdPal: function (){
            //find and update signer owner prop: idpal_verification
            let vm = this;
            let owners = this.merchant.owners;
            //on the basis we have only one signer
            let payload = owners.map(owner => {
                if (!!owner.owner_email && !!vm.user.email &&
                        owner.owner_email === vm.user.email && owner.is_signatory ==='1') {
                    owner.idpal_verification = '0';
                    owner.idpal_uuid = '';
                }
                return owner;
            });
            payload.section = 'PRINCIPAL';

            //unset the principal idpal fields ( update principal)
            this.updateMerchantSignerOwner(payload)

            this.show_idpal_section = false;
        },
        updateMerchantEkyc: function (){
            let vm = this;
            //find and update signer owner prop: ekyc_verification
            let owners = this.merchant.owners;
            //on the basis we have only one signer
            let payload = owners.map(owner => {
                if (!!owner.owner_email && !!vm.user.email &&
                    owner.owner_email === vm.user.email && owner.is_signatory ==='1') {
                    owner.ekyc_verification = vm.ekyc_verification;
                }
                return owner;
            });
            payload.section = 'PRINCIPAL';

            this.updateMerchantSignerOwner(payload);
        },
        updateMerchantSignerOwner: function(payload) {
            let vm = this;
            //updated pass payload from updateMerchantEkyc and
            //find and update signer owner prop: ekyc_verification
            // let owners = this.merchant.owners;
            // //on the basis we have only one signer
            // let payload = owners.map(owner => {
            //     console.log('owner :=> ', owner);
            //     if (owner.is_signatory ==='1') {
            //         owner.ekyc_verification = vm.ekyc_verification;
            //     }
            //    return owner;
            // });
            // payload.section = 'PRINCIPAL';
            // console.log('payload:=>', payload)

            vm[types.SAVE_MERCHANT](payload).then(response => {
                if (response.data.result === 'SUCCESS') {
                    //reinit validation rules
                    vm.initDocumentValidationRulesByConfig();
                    //reset UI order
                    vm.document_categories = vm.orderedDocumentCategories(vm.document_categories);

                    //vm.notifySuccess(vm.lang('principals_updated_successfully'));
                    if (!!callback) { //call back is the next function in nav guard
                        callback();
                    }
                }
            }).catch(error => {
                //console.log(error)
            });

        },
        orderedDocumentCategories: function(document_categories) {
            let vm = this;
            // console.log('doc Cat Payload', document_categories);

            if (this.timerExpired('orderedDocumentCategories')) {
                this.initDocumentValidationRulesByConfig();
            }

            let listed_tenant_category_external_ids = document_categories.map(category => {
                return category.tenant_udc_external_id
            });

            let has_priority_order_at_tenant_level = vm.tenantUploadCategories.some(tenant_category => {
                let is_listed_tenant_category = listed_tenant_category_external_ids.includes(
                    tenant_category.tenant_udc_external_id);

                let has_priority = tenant_category.hasOwnProperty('priority_order') &&
                    parseInt(tenant_category.priority_order) > 0;

                return is_listed_tenant_category && has_priority;
            });

            console.log('has_priority_order_at_tenant_level', has_priority_order_at_tenant_level);

            let document_categories_with_priority_order_field = has_priority_order_at_tenant_level ?
                document_categories.map(category => {
                    let tenantCategory = vm.tenantUploadCategories.find(tenant_category => {
                        return tenant_category.tenant_udc_external_id === category.tenant_udc_external_id;
                    });

                    // console.log('tenantCategory => ', tenantCategory);
                    let priority_order = tenantCategory.hasOwnProperty('priority_order') ?
                        tenantCategory.priority_order :
                        category.hasOwnProperty('priority_order') ? category.priority_order : 0;

                    return {
                        ...category,
                        priority_order: priority_order
                    }
                }) : document_categories;

            //updating the requirementState
            document_categories_with_priority_order_field =
                document_categories_with_priority_order_field.map(categoryObj => {
                    let validation_rules = vm.document_categories_validation_rules;
                    return {
                        ...categoryObj,
                        requiredState: validation_rules && categoryObj.category_code &&
                        Object.keys(validation_rules).includes(categoryObj.category_code) ?
                            'M' : 'O',
                    }
                });

            document_categories_with_priority_order_field.sort((a,b) => vm.orderByPriorityOrder(a,b));

            //console.log('doc Cat Payload Updated', document_categories_with_priority_order_field);
            return document_categories_with_priority_order_field;
        },
        orderByPriorityOrder: function(a, b) {
            //console.log(a, b);
            let priority_a =  parseInt(a.priority_order);
            let priority_b = parseInt(b.priority_order);

            let a_is_mandatory = a.requiredState === 'M';
            let a_is_optional = a.requiredState === 'O';
            let b_is_mandatory = b.requiredState === 'M';
            let b_is_optional = b.requiredState === 'O';

            let both_are_mandatory = a_is_mandatory && b_is_mandatory;
            let both_are_optional = a_is_optional && b_is_optional;

            if (both_are_mandatory || both_are_optional) {
                let one_of_is_zero = priority_a === 0 || priority_b === 0;
                //priority_order 0 means not ranked
                if (one_of_is_zero) {
                    if (priority_a > priority_b) {
                        return -1
                    }

                    if (priority_a < priority_b) {
                        return 1
                    }
                }
                return priority_a - priority_b;
            } else if (a_is_optional && b_is_mandatory) {
                return 1
            } else if (a_is_mandatory && b_is_optional) {
                return -1
            }
        },
        categoryIsOptional: function (category){
            let vm = this;

            if (vm.isSignerUser && !!category && !!vm.signerOwner) {
                const signer_upload_document_category = vm.getSignerUploadDocumentCategory;
                const doc_cat = !!signer_upload_document_category ? signer_upload_document_category.find((signer_up_doc_cat) => {
                    if (!!category.id && !!signer_up_doc_cat.document_category_external_id && category.id === signer_up_doc_cat.document_category_external_id) {
                        return signer_up_doc_cat;
                    }
                }) : null;
                const has_ekyc_set = (vm.ekycAllowedByWorkflow && !!vm.signerOwner.ekyc_verification && vm.signerOwner.ekyc_verification == '1');
                const has_idpal_set = (vm.isIdPalWorkflowConfigured && vm.signerOwner.idpal_verification && vm.signerOwner.idpal_verification == '1');
                const has_bankid_set = (vm.canUseBankIdVerify && vm.signerOwner.is_bank_id_verified && vm.signerOwner.is_bank_id_verified == '1');

                return (has_ekyc_set || has_bankid_set || !doc_cat);
            }
            return category && category.hasOwnProperty('category_code')
                && vm.optional_document_categories.hasOwnProperty(category.category_code)
                && this.objectIsNotEmpty(this.optional_document_categories[category.category_code]);
        },
        timerExpired: function(operation) {
            let vm = this;
            if (vm.time_dilation.hasOwnProperty(operation)) {
                let diff = (new Date().getTime() - vm.time_dilation[operation])/(60*1000);
                if (diff > 2) {
                    vm.time_dilation[operation] = new Date().getTime();
                    return true;
                }
            }
            else {
                vm.time_dilation[operation] = new Date().getTime();
                return true;
            }

            return false;
        },
        getDocumentCategoryMessage: function(category_id) {
            let udc = this.parameters && this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            let has_udc = Array.isArray(udc) && udc.length > 0 && udc.some(obj => {
                return obj.document_category_external_id === category_id
            });
            let category = has_udc ? udc.find(obj => {
                return obj.document_category_external_id === category_id
            }) : null;
            let message = '';

            if (category_id && has_udc) {
                if (this.timerExpired('getDocumentCategoryMessage') &&
                    !Object.values(this.document_categories_validation_rules).some(obj => {
                        return obj.hasOwnProperty('message_key')
                    })
                ) {
                    this.initDocumentValidationRulesByConfig();
                }

                let category_code = category.hasOwnProperty('category_code') ? category.category_code : null
                if (category_code && this.document_categories_validation_rules[category_code]) {
                    message = this.lang('single_document_upload_help_prefix') + '<br>';
                    let validation_payload = this.document_categories_validation_rules[category_code]
                    message = message + this.lang(validation_payload.message_key) +
                        this.lang('minimum_number') + validation_payload.minimum;
                }
            }
            return message
        },
        getDocumentCategorySubMessage: function(category_id) {
            let vm = this;
            let udc = vm.parameters && vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                vm.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            let has_udc = Array.isArray(udc) && udc.length > 0 && udc.some(obj => {
                return obj.document_category_external_id === category_id
            });
            let category = has_udc ? udc.find(obj => {
                return obj.document_category_external_id === category_id
            }) : null;
            let message = '';

            if (category_id && has_udc) {
                if (vm.timerExpired('getDocumentCategoryMessage') &&
                    !Object.values(vm.document_categories_validation_rules).some(obj => {
                        return obj.hasOwnProperty('message_key');
                    })
                ) {
                    vm.initDocumentValidationRulesByConfig();
                }

                let category_code = category.hasOwnProperty('category_code') ? category.category_code : null;
                // if (category_code && vm.document_categories_validation_rules[category_code]) {
                if (category_code && vm.document_category_validation_message_key[category_code]) {
                    let message_payload = vm.document_category_validation_message_key[category_code];
                    let message_key_sub_text = message_payload.notice_key + '_sub_text';
                    if (!vm.lang(message_key_sub_text).includes(message_payload.notice_key + '_sub_text')) {
                        message = message + vm.lang(message_key_sub_text);
                    }
                }
            }
            return message;
        },
        validateDocumentsByConfig: function(documents) {
            let vm = this
            //console.log('validateDocumentsByConfig')
            documents.forEach((document) => {
                let tenant_category = !!this.parameters? this.parameters['TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'].find(tenantDocCategory => {
                    let field = 'tenant_udc_external_id'
                    return tenantDocCategory[field] === document[field]
                }):[];
                if(!!tenant_category && Object.keys(tenant_category).length>0) {
                    let upload_category = this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'].find(docCategory => {
                        return docCategory.document_category_external_id === tenant_category.id
                    })
                    let tenant_type = this.parameters['TENANT_UPLOAD_DOCUMENT_TYPE_PARAM'].find(tenantDocType => {
                        let field = 'tenant_upload_document_type_external_id';
                        return tenantDocType[field] === document[field]
                    });

                    Object.keys(this.document_categories_validation_rules).forEach((category_code) => {
                        let document_category_validation_rules = this.document_categories_validation_rules[category_code]
                        if(upload_category['category_code'] === category_code) {
                            if(document_category_validation_rules.catalogue.length === 0) {
                                let temp ={}
                                temp.type = tenant_type.reference
                                if(!!document.values) {
                                    document.values.forEach(value => {
                                        temp[value.field_name] = value.field_value
                                    })
                                }

                                temp.type = tenant_type.reference
                                document_category_validation_rules.catalogue = [temp]
                                document_category_validation_rules.count++
                            }
                            else {
                                let similar = false
                                let temp ={}
                                if(!!document.values) {
                                    document.values.forEach(value => {
                                        temp[value.field_name] = value.field_value
                                    })

                                    document_category_validation_rules.catalogue.forEach(values => {
                                        for( let [field, value] of Object.entries(values) ) {
                                            if ( value === temp[field] ) {
                                                similar = true
                                                break
                                            }
                                        }
                                    })
                                }

                                if(!similar || !document_category_validation_rules.unique) {
                                    temp.type = tenant_type.reference
                                    document_category_validation_rules.catalogue.push(temp)
                                    document_category_validation_rules.count++
                                }

                            }
                        }
                    })
                }
            })
        },
        initDocumentValidationRulesByConfig: function() {
            //console.log('initDocumentValidationRulesByConfig')
            let vm = this
            //flush default rules
            vm.document_categories_validation_rules = {};
            vm.optional_document_categories = {};
            let upload_categories = (!!this.parameters && this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            let has_upload_categories = upload_categories.length > 0

            let tenant_upload_categories = (!!this.parameters && this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                this.parameters['TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
            let has_tenant_upload_categories =  tenant_upload_categories.length > 0

            if (has_upload_categories && has_tenant_upload_categories) {
                // console.log("tenant_upload_categories1", tenant_upload_categories)
                tenant_upload_categories.forEach(tenant_upload_category => {
                    let has_is_required = tenant_upload_category.hasOwnProperty('is_required')
                    let has_required_count = tenant_upload_category.hasOwnProperty('required_count')

                    let document_category_required_yes = has_is_required &&
                        tenant_upload_category.is_required === DOCUMENT_CATEGORY_REQUIRED_YES
                    let document_category_required_conditional = has_is_required &&
                        tenant_upload_category.is_required === DOCUMENT_CATEGORY_REQUIRED_CONDITIONAL

                    if (has_is_required && has_required_count) {
                        let category_code = upload_categories.find(upload_category => {
                            let field = 'document_category_external_id';
                            return upload_category[field] === tenant_upload_category[field]
                        })['category_code']

                        let category_key_available = category_code ?
                            Object.keys(vm.document_category_validation_message_key).includes(category_code) :
                            false

                        if (category_key_available && has_required_count) {
                            let obj = new DocumentCategoryValidationSet()
                            obj.minimum = tenant_upload_category['required_count']
                            obj.message_key = vm.document_category_validation_message_key[category_code].notice_key

                            if (document_category_required_yes ||
                                (document_category_required_conditional &&
                                    vm.documentCategoryConditionCriteriaSatisfied(tenant_upload_category))
                            ) {
                                vm.document_categories_validation_rules[category_code] = obj;
                                vm.document_categories_required++;
                            }else{
                                vm.optional_document_categories[category_code] = obj
                            }
                        }
                    }
                })
                // console.log("document_categories_validation_rules", vm.document_categories_validation_rules)
                // console.log("optional_document_categories", vm.optional_document_categories)
            }

        },
        documentCategoryConditionCriteriaSatisfied: function(tenant_upload_category) {
            //console.log('documentCategoryConditionCriteriaSatisfied')
            let vm = this
            let doc_category_conditional_criteria = this.parameters &&
                this.parameters.hasOwnProperty('DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_PARAM') ?
                this.parameters['DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_PARAM'] : [];
            let has_doc_category_conditional_criteria = doc_category_conditional_criteria.length > 0

            let tenant_doc_category_conditional_config = this.parameters &&
                this.parameters.hasOwnProperty('TENANT_DOCUMENT_CATEGORY_CONDITIONAL_CONFIG_PARAM') ?
                this.parameters['TENANT_DOCUMENT_CATEGORY_CONDITIONAL_CONFIG_PARAM'] : [];

            tenant_doc_category_conditional_config = tenant_doc_category_conditional_config.filter(criteria_config => {
                let field = 'tenant_udc_external_id'
                return criteria_config[field] === tenant_upload_category[field]
            })

            let has_tenant_doc_category_conditional_config =  tenant_doc_category_conditional_config.length > 0

            if (has_doc_category_conditional_criteria && has_tenant_doc_category_conditional_config) {
                //group tenant_doc_category_conditional_config by conditional_criteria_external_id
                let grouped_tenant_doc_category_conditional_config = {}
                let all_conditional_criteria_external_ids_present = true
                tenant_doc_category_conditional_config.forEach(criteria_config => {
                    let key = criteria_config['conditional_criteria_external_id']
                    if (key) {
                        if (!grouped_tenant_doc_category_conditional_config.hasOwnProperty(key)) {
                            grouped_tenant_doc_category_conditional_config[key] = []
                        }
                        grouped_tenant_doc_category_conditional_config[key].push(criteria_config)

                        //check all conditional_criteria_external_ids are present in doc_category_conditional_criteria
                        if (all_conditional_criteria_external_ids_present) {
                            let conditional_criteria_external_id_present =
                                doc_category_conditional_criteria.find(criteria => {
                                    return criteria['conditional_criteria_external_id'] === key
                                })

                            if (!conditional_criteria_external_id_present) {
                                all_conditional_criteria_external_ids_present = false
                            }
                        }
                    }
                })

                let all_criteria_satisfied = true

                if (all_conditional_criteria_external_ids_present) {
                    for(const [key, criteria_entries] of Object.entries(grouped_tenant_doc_category_conditional_config)) {
                        let criteriaItem = doc_category_conditional_criteria.find(criteria_item => {
                            return criteria_item['conditional_criteria_external_id'] === key
                        });

                        if (criteriaItem['criteria_code'] === DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_BUSINESS_TYPE) {
                            //vm.merchant.ownership_entity_type check if listed
                            // console.log('Business Type Decision Point', vm.merchant.ownership_entity_type, criteria_entries)
                            let entity_type_present = criteria_entries.some(entry => {
                                let field = 'included_entity';
                                return entry.hasOwnProperty(field) && entry[field] === vm.merchant.ownership_entity_type
                            });

                            if (!entity_type_present) {
                                all_criteria_satisfied = false
                            }
                        }

                        if (criteriaItem['criteria_code'] === DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_NO_BANK_ID) {
                            //vm.merchant.ownership_entity_type check if listed
                            // console.log('NO BANK ID Decision Point', vm.merchant, criteria_entries)

                            let signer_bank_id_verified = criteria_entries.some(entry => {
                                let field = 'included_entity'
                                return entry.hasOwnProperty(field) && vm.merchant && vm.merchant.hasOwnProperty('owners') ?
                                        vm.merchant.owners.some(owner => {
                                            let is_login_user = !!vm.signerOwner && !!vm.signerOwner.owner_ref && owner.owner_ref == vm.signerOwner.owner_ref;
                                            return is_login_user && parseInt(owner.is_signatory) === 1 &&
                                                    parseInt(owner.is_bank_id_verified) === parseInt(entry[field])
                                        }) :
                                        false;
                            });

                            if (signer_bank_id_verified) {
                                all_criteria_satisfied = false;
                            }
                        }

                        if (criteriaItem['criteria_code'] === DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_EKYC) {
                            //vm.merchant.ownership_entity_type check if listed
                            //console.log('EKYC Decision Point', vm.merchant, criteria_entries);

                            let signer_todo_ekyc_verification = criteria_entries.some(entry => {
                                let field = 'included_entity';
                                return entry.hasOwnProperty(field) && vm.merchant && vm.merchant.hasOwnProperty('owners') ?
                                        vm.merchant.owners.some(owner => {
                                            //console.log('ekycverification', owner.is_signatory, owner.ekyc_verification, entry[field])
                                            let is_login_user = !!vm.signerOwner && !!vm.signerOwner.owner_ref && owner.owner_ref == vm.signerOwner.owner_ref;
                                            return is_login_user && parseInt(owner.is_signatory) === 1 &&
                                                    parseInt(owner.ekyc_verification) !== parseInt(entry[field]);
                                        }) :
                                        false;
                            });

                            if (signer_todo_ekyc_verification) {
                                all_criteria_satisfied = false;
                            }
                        }

                        if (criteriaItem['criteria_code'] === DOCUMENT_CATEGORY_CONDITIONAL_CRITERIA_NO_ID_PAL) {
                            //vm.merchant.ownership_entity_type check if listed

                            let signer_idpal_verified = criteria_entries.some(entry => {
                                let field = 'included_entity';
                                return entry.hasOwnProperty(field) && vm.merchant && vm.merchant.hasOwnProperty('owners') ?
                                        vm.merchant.owners.some(owner => {
                                            let is_login_user = !!vm.signerOwner && !!vm.signerOwner.owner_ref && owner.owner_ref == vm.signerOwner.owner_ref;
                                            return (is_login_user && parseInt(owner.is_signatory) === 1 &&
                                                    parseInt(owner.idpal_verification) === parseInt(entry[field]));
                                        }) :
                                        false;
                            });

                            if (signer_idpal_verified) {
                                all_criteria_satisfied = false;
                            }
                        }
                    }
                }

                return all_criteria_satisfied
            }

            //return false by default
            return false
        },
        formatSize: function (data) {
            return this.convertToDecimal(parseInt(data) / 1000000) + 'mb';
        },
        getEntityList: function (document_entity_id) {
            const params = this.parameters.hasOwnProperty('DOCUMENT_ENTITIES_PARAM') ?
                this.parameters.DOCUMENT_ENTITIES_PARAM : [];

            const entity_meta_data = params.find(meta_data => meta_data.id == document_entity_id);
            const entity_key_map = {
                DOCUMENT_ENTITY_CODE_PRINCIPAL: 'owner_ref',
                DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT: 'contact_ref',
                DOCUMENT_ENTITY_CODE_OUTLET_BANK: 'bank_id',
            };

            // remove previously selected entities from list
            // we do this by getting any random list and unsetting the entity using it's id from list
            if (!!this.document_entities_map[document_entity_id]) {
                const first_entity_id = Object.keys(this.document_entities_map[[document_entity_id]])[0];
                return this.document_entities_map[document_entity_id][first_entity_id].filter((entity) => {
                    const entity_key = entity_key_map[document_entity_id];
                    return entity[entity_key] != first_entity_id;
                });
            }

            // else get unfiltered List
            return this.getUnfilteredEntityList(entity_meta_data.entity_code);
        },
        getUnfilteredEntityList: function(entity_code) {
            if (this.isSignerUser && entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                this.merchant.owners = !!this.merchant.owners ? this.merchant.owners : [];
                const owner_lists = this.merchant.owners.reduce((owner_lists, owner) => {
                    if (!!this.signerOwner && owner.owner_ref == this.signerOwner.owner_ref) {
                        owner_lists.push({
                            id: owner.owner_ref,
                            text: this.getOwnerListsNames(owner)
                        });
                    }
                    return owner_lists;
                }, []);
                return owner_lists;
            } else if (entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                this.merchant.owners = !!this.merchant.owners ? this.merchant.owners : [];
                const owner_lists = this.merchant.owners.reduce((owner_lists, owner) => {
                    owner_lists.push({
                        id: owner.owner_ref,
                        text: this.getOwnerListsNames(owner)
                    });
                    return owner_lists;
                }, []);
                return owner_lists;
            } else if (entity_code === DOCUMENT_ENTITY_CODE_BUSINESS) {
                return [{
                    id: this.merchant._id,
                    text: this.merchant.legal_name
                }];
            }  else if (entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT) {
                const business_address = this.merchant.registration_address;
                return [{
                    id: this.merchant.registration_address.contact_ref,
                    text: `${business_address.street_line_1} ${business_address.zip_code}`
                }];
            }
            // else if (entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_BANK) {
            //     this.merchant.banks = !!this.merchant.banks ? this.merchant.banks : [];
            //     const bank_lists = this.merchant.banks.reduce((bank_lists, bank) => {
            //         //console.log(bank);
            //         bank_lists.push({
            //             id: bank.bank_id,
            //             text: `${bank.account_holder_name} - ${bank.bank_account_number_masked}`
            //         });
            //         return bank_lists;
            //     }, []);
            //     return bank_lists;
            // } else if (entity_code === DOCUMENT_ENTITY_CODE_OUTLET_BANK) {
            //     this.outlet.banks = !!this.outlet.banks ? this.outlet.banks : [];
            //     const bank_lists = this.outlet.banks.reduce((bank_lists, bank) => {
            //         bank_lists.push({
            //             id: bank.bank_id,
            //             text: `${bank.account_holder_name} - ${bank.bank_account_number_masked}`
            //         });
            //         return bank_lists;
            //     }, []);
            //     return bank_lists;
            // }

            return [];
        },
        isDocumentEditable: function (document) {
            return document && document.review_status !== types.DOCUMENT_REVIEW_STATUS_APPROVED;
        },
        getOwnerListsNames: function (owner_data) {
            let vm = this;
            if (!!owner_data) {
                let title = ['752', '578'].includes(this.baseCountryCode) ? '' : owner_data.owner_title !== 'other' ? this.formatTitle(owner_data.owner_title) : this.formatTitle(owner_data.other_owner_title);
                return `${title} ${owner_data.owner_first_name} ${owner_data.owner_surname}`;
            }
            return '';
        },
        formatEntityName: function (document_entity_id, selected_entity_id) {
            const params = this.parameters.hasOwnProperty('DOCUMENT_ENTITIES_PARAM') ?
                this.parameters.DOCUMENT_ENTITIES_PARAM : [];

            const entity_meta_data = params.find(meta_data => meta_data.id == document_entity_id);

            if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                this.merchant.owners = !!this.merchant.owners ? this.merchant.owners : [];
                const owner = this.merchant.owners.find((owner) => owner.owner_ref == selected_entity_id);
                if (!!owner) {
                    return this.getOwnerListsNames(owner);
                }
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS) {
                return this.merchant.legal_name;
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT) {
                return `${this.merchant.registration_address.street_line_1} ${this.merchant.registration_address.zip_code}`;
            }

            return '';
        },
        selectDocument: function (category, category_index) {
            // console.log('selectDocument:=>');
            let vm = this;
            category.selected = '1';

            let document = vm.documents.find(document => {
                let has_doc_cat_ext_id = document.document_category_external_id === category.id;
                let has_doc_type_ext_id = document.hasOwnProperty('upload_document_type_external_id') &&
                    document.upload_document_type_external_id === category.document_type_external_id;

                return has_doc_cat_ext_id && has_doc_type_ext_id;
            });

            if (vm.isSignerUser) {
                // vm.setSignatoryProofOfIdDocumentToUpload();
                vm.setDocumentToUploadForAdditionalSignatory(document, category);
                if (document.values && Array.isArray(document.values) && document.values.length > 0) {
                    vm.category_has_document_entity.push(category_index);
                }
            }
            else if (document) {
                // if new instance needs to be created clone the document
                if (document.selected === '1' && document.hasOwnProperty('document_entity_id')) {
                    this.cloneDocument(document);
                } else {
                    if (category.hasOwnProperty('category_code') && !!category.category_code && category.category_code === 'PROOF_OF_ID') {
                        this.setDocumentEntity(document);
                    }
                    document.selected = '1';
                }

                if (document.values && Array.isArray(document.values) && document.values.length > 0) {
                    vm.category_has_document_entity.push(category_index);
                }
            }
            category.document_type_external_id = '';
        },
        categoryHasDocumentEntity: function (category) {
            let vm = this;

            if (!vm.isSelectedDocumentCategory(category)) {
                return false;
            }

            let documents = vm.documents.filter(document => document.document_category_external_id === category.id);

            if (!!documents && Array.isArray(documents)) {
                return documents.some(document => vm.isSelectedDocument(document) && document.values
                    && vm.someDocumentValueHasSelected(document.values));
            }

            return false;
        },
        someDocumentValueHasSelected: function (values) {
            let vm = this;
            return values && Array.isArray(values) && values.some(value => vm.isSelectedDocumentValue(value));
        },
        isSelectedDocumentValue: function (value) {
            return value && value.attribute && value.attribute.selected === '1';
        },
        isSelectedDocument: function (document) {
            return document && document.selected === '1';
        },
        isSelectedDocumentCategory: function (category) {
            return category && category.selected;
        },
        cloneDocument: function (doc) {
            let cloned_doc = JSON.parse(JSON.stringify(doc));
            cloned_doc.selected_entity_id = '';
            cloned_doc.document_external_id = '';
            cloned_doc.uploaded_files = [];
            cloned_doc.values.map(value => {
                if(value.attribute.type == 'country_param') {
                    value.field_value = this.getAllianceCountryCode();
                } else {
                    value.field_value = '';
                }
            });

            delete cloned_doc.entity;
            this.documents.push(cloned_doc);
        },
        removeDocument: function (document, category_index) {
            let vm = this;

            const main_signatory = vm.merchant.owners.find(owner => {
                return owner.is_signatory == '1' && !!vm.mainMerchantUser && !!vm.mainMerchantUser.email && vm.mainMerchantUser.email === owner.owner_email;
            });

            if (!!main_signatory && !!main_signatory.owner_ref && !vm.isSignerUser) {
                const upload_category = vm.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => obj.document_category_external_id === document.document_category_external_id);
                if (upload_category.category_code === 'PROOF_OF_ID' && document.selected == '1' &&
                    document.selected_entity_id !== main_signatory.owner_ref) {
                    vm.merchant.signatories_upload_documents_flag = 0;
                }
            }

            document.selected = '0';
            document.selected_entity_id = '';
            document.uploaded_files = [];
            document.values.map(value => {
                value.field_value = '';
                this.setDefaultCountry(value);
            });

            this.category_has_document_entity = this.category_has_document_entity.filter((ctg_index) => {
                return ctg_index !== category_index;
            }, category_index);

            delete document.entity;
        },
        setDocumentEntity: function (docEntity) {
            // set document entity
            const params = this.parameters.hasOwnProperty('DOCUMENT_ENTITIES_PARAM') ?
                this.parameters.DOCUMENT_ENTITIES_PARAM : [];
            const entity_meta_data = params.find(meta_data => meta_data.id == docEntity.document_entity_id);

            let selectedEntity = {};

            if (this.isSignerUser && entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                const entity_list = (this.isSignerUser && docEntity.hasOwnProperty('selected_entity_id') &&
                                    docEntity.selected_entity_id == this.signerOwner.owner_ref)
                                    ? [this.signerOwner] : this.merchant.owners;
                if (entity_list.length === 1 && entity_list[0].owner_ref == docEntity.selected_entity_id) {
                    const owner = entity_list[0];
                    selectedEntity = owner;
                    docEntity.selected_entity_id = owner.owner_ref;
                }
                else {
                    entity_list.forEach((owner) => {
                        if (owner.owner_ref == docEntity.selected_entity_id) {
                            selectedEntity = owner;
                            docEntity.selected_entity_id = owner.owner_ref;
                        }
                    });
                }
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                const entity_list = (!!this.document_entities_map[docEntity.document_entity_id]) ? !!this.document_entities_map[docEntity.document_entity_id] : this.merchant.owners;
                if(entity_list.length == 1) {
                    const owner = entity_list[0];
                    selectedEntity = owner;
                    docEntity.selected_entity_id = owner.owner_ref;
                } else {
                    entity_list.forEach((owner) => {
                        if (owner.owner_ref == docEntity.selected_entity_id) {
                            selectedEntity = owner;
                            docEntity.selected_entity_id = owner.owner_ref;
                        }
                    });
                }
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS) {
                selectedEntity = this.merchant;
                docEntity.selected_entity_id = this.merchant._id;
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT) {
                selectedEntity = this.merchant.registration_address;
                docEntity.selected_entity_id = this.merchant.registration_address.contact_ref;
            } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_BANK) {
                if(entity_list.length == 1) {
                    const bank = entity_list[0];
                    selectedEntity = bank;
                    docEntity.selected_entity_id = bank.bank_id;
                } else {
                    this.merchant.banks.forEach((bank) => {
                        if (bank.bank_id == docEntity.selected_entity_id) {
                            selectedEntity = bank;
                            docEntity.selected_entity_id = bank.bank_id;
                        }
                    });
                }
            }

            docEntity.values.map(value => {
                if (value.attribute.dependent == 'Y') {
                    const field_key = value.attribute.entity;
                    value.field_value = selectedEntity[field_key];
                }
            });
        },
        removeFile: function (files, ref = 0, document) {
            files.splice(ref, 1);
        },
        formatUploadDocumentCategory: function (data) {
            return this.formatSelectType(this.parameters, data, 'UPLOAD_DOCUMENT_CATEGORY_PARAM')
        },
        formatUploadDocumentType: function (data) {
            let vm = this;
            let param = {};
            param['TENANT_UPLOAD_DOCUMENT_TYPE_PARAM'] = vm.parameters && vm.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_TYPE_PARAM') ?
                vm.parameters['TENANT_UPLOAD_DOCUMENT_TYPE_PARAM'] : [];

            let upload_document_type_external_id = data; //for the original use-cases

            //some document types are shared. There is a possibility searching with document_type_external_id will yield the wrong result.
            let has_upload_document_type_external_id = data.hasOwnProperty('upload_document_type_external_id');
            let has_tenant_udc_external_id = data.hasOwnProperty('tenant_udc_external_id');

            if (has_tenant_udc_external_id && has_upload_document_type_external_id) {
                upload_document_type_external_id = data['upload_document_type_external_id'];
                param['TENANT_UPLOAD_DOCUMENT_TYPE_PARAM'] = param['TENANT_UPLOAD_DOCUMENT_TYPE_PARAM'].filter(document_type => {
                    return document_type.tenant_udc_external_id === data['tenant_udc_external_id'];
                });

            } else if (has_upload_document_type_external_id) {
                upload_document_type_external_id = data['upload_document_type_external_id'];
            }

            return this.formatSelectType(param, upload_document_type_external_id, 'TENANT_UPLOAD_DOCUMENT_TYPE_PARAM')
        },
        noExpectsDocumentUpload: function (owner) {
            return owner.ekyc_verification == "1" || owner.idpal_verification == "1" || owner.is_bank_id_verified == "1";
        },
        getDocumentTooltipContent: function (document) {
            let vm = this
            let tooltip = '';
            let {upload_document_type_external_id} = document
            let upload_documents = vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_TYPE_PARAM') ? vm.parameters['UPLOAD_DOCUMENT_TYPE_PARAM'] : []
            let upload_document = upload_documents.find(f => f.upload_document_type_external_id === upload_document_type_external_id)
            //set tooltip for germany only
            if (defaultCountry === '276' && upload_document && upload_document.hasOwnProperty('document_code')) {
                let name = upload_document.document_code;
                tooltip = this.getTooltipText(name.toLowerCase() + '_documents')
            }
            return tooltip;
        },
        getUploadDocumentTypeParams: function (id) {
            let params = this.parameters.TENANT_UPLOAD_DOCUMENT_TYPE_PARAM.filter(obj => {
                return obj.document_category_external_id == id;
            });

            params.unshift({id: '', text : this.lang('select_document_types')});
            return params;
        },
        submitPrevent: function (){

        },
        getDocumentCategoryName: function (id) {
            let param = this.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                return obj.document_category_external_id === id
            });

            return !!param.category_name ? param.category_name : '';
        },
        validateUploadDocument: function () {
            //copied code from uploadDocument function to separate the validation logic and ajax call
            let vm = this;

            let validForm = this.validateForm('#document_upload_form');
            if (!validForm) {
                return false;
            }

            let valid_documents = vm.validateDocuments();

            if (!vm.all_signatories_validated && !vm.isSoleTrader && !vm.isSignerUser && !vm.signatories_validated_has_error_message) {
                vm.all_signatories_validated = true;
                $('#signatories_id_document_modal').modal('show');
            }
            return valid_documents;
        },
        validateDocuments: function(show_notification = true) {
            let vm = this;

            vm.initDocumentValidationRulesByConfig();

            // validate all signatories document uploaded
            const signatories = this.merchant.owners.filter(owner => owner.is_signatory == '1');

            // what if current owner uses idpal, and other owners need to upload but didnt
            let has_uploaded_doc_file = vm.hasUploadedFiles;
            if (vm.isSignerUser) {
                has_uploaded_doc_file = vm.signerHasUploadedFiles();
            }
            if (!has_uploaded_doc_file && !vm.noExpectsDocumentUpload(vm.signerOwner)) {
                if (Object.keys(vm.document_categories_validation_rules).length > 0) {
                    if(show_notification){
                        this.notifyError(this.lang("upload_file_to_proceed"));
                    }
                    return false;
                }
                if (vm.isSoleTrader || (!!signatories && signatories.length === 1) || vm.merchant.signatories_upload_documents_flag === '1') {
                    return true;
                }
            }

            const unUploadedDoc = this.documents.find(doc => doc.selected === '1' && !(doc.uploaded_files.length > 0));
            if (unUploadedDoc) {
                // console.log('unUploadedDoc:=>', unUploadedDoc);
                if(show_notification) {
                    this.notifyError('', `${this.lang("upload_file_for")} ${this.formatUploadDocumentType(unUploadedDoc)}`);
                }
                return false;
            }

            // validate all document uploaded
            const required_docs = this.requiredDocs;

            let tenant_upload_document_categories = (!!this.parameters && this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                this.parameters.TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM : [];

            let upload_document_categories = (!!this.parameters && this.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];

            let upload_document_category_proof_id = upload_document_categories.find(upload_category => {
                return upload_category.category_code == 'PROOF_OF_ID';
            });

            let signers_required_upload_category = tenant_upload_document_categories.length > 0
                ? tenant_upload_document_categories.some(tenant_upload_category => {
                    return tenant_upload_category.hasOwnProperty('is_signers_required_document_category') &&
                    tenant_upload_category.is_signers_required_document_category === '1';
                }) : null;

            let signatories_length = signatories.length;
            let all_signatories_validated = true;
            vm.signatories_validated_has_error_message = false;
            signatories.forEach(signatory => {
                let is_main_merchant = !!vm.mainMerchantUser && !!vm.mainMerchantUser.email && vm.mainMerchantUser.email == signatory.owner_email;
                const identifiedSignatory = this.documents.find(doc => {
                    // check if any selected proof of id document is assigned to signatory
                    const upload_category = !!this.parameters?
                        this.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => obj.document_category_external_id === doc.document_category_external_id):[];
                    return doc.selected == '1' &&
                        upload_category.category_code == 'PROOF_OF_ID' &&
                        doc.selected_entity_id == signatory.owner_ref;
                });
                let logged_signatory = !!vm.user.email && signatory.owner_email === vm.user.email;
                let no_expected_document_upload = vm.noExpectsDocumentUpload(signatory);
                let proof_of_id_required_by_config = Object.keys(required_docs).some(element => element === 'PROOF_OF_ID');

                if (!identifiedSignatory && proof_of_id_required_by_config) {
                    if (vm.isSoleTrader || (vm.isSignerUser && logged_signatory && !no_expected_document_upload && signers_required_upload_category) || signatories_length === 1 || (!vm.isSignerUser && is_main_merchant && !no_expected_document_upload)) {
                        vm.notifyError('', `${this.lang("upload_identifcation_document_for")} ${signatory.owner_title !== 'other' ? signatory.owner_title : signatory.other_owner_title} ${signatory.owner_first_name} ${signatory.owner_surname}`);
                        all_signatories_validated = false;
                        vm.signatories_validated_has_error_message = true;
                    }
                    else if (signatories_length > 1 && signers_required_upload_category && vm.merchant.signatories_upload_documents_flag == '0' && !no_expected_document_upload && !vm.isSignerUser) {
                        all_signatories_validated = false;
                        vm.all_signatories_validated = false;
                    }
                } else if (!identifiedSignatory && !proof_of_id_required_by_config) {
                    if (vm.isSignerUser && signers_required_upload_category && logged_signatory && !no_expected_document_upload) {
                        vm.notifyError('', `${this.lang("upload_identifcation_document_for")} ${signatory.owner_title !== 'other' ? signatory.owner_title : signatory.other_owner_title} ${signatory.owner_first_name} ${signatory.owner_surname}`);
                        all_signatories_validated = false;
                        vm.signatories_validated_has_error_message = true;
                    }
                    else if (!vm.isSoleTrader && signatories_length > 1 && signers_required_upload_category && vm.merchant.signatories_upload_documents_flag == '0' && !no_expected_document_upload && !is_main_merchant && !vm.isSignerUser) {
                        all_signatories_validated = false;
                        vm.all_signatories_validated = false;
                    }
                }
            });

            let all_required_docs_validated = true;

            this.validateDocumentsByConfig(this.uploadedDocuments)

            for(const [category_code, validation_rules] of Object.entries(this.document_categories_validation_rules)) {
                let has_required_document = true
                has_required_document = !!has_required_document ?
                    (validation_rules.count >= validation_rules.minimum) :
                    has_required_document

                if (!has_required_document && !vm.noExpectsDocumentUpload(vm.signerOwner) && !vm.isSignerUser) {
                    vm.notifyError('',`${vm.lang(required_docs[category_code])} ${vm.lang("document_is_required")}
                    ${vm.lang('minimum_number')+validation_rules.minimum}`);
                    all_required_docs_validated = false;
                }
            }

            return !(!all_signatories_validated || !all_required_docs_validated);
        },
        uploadDocument: function (to_path = null) {
            let vm = this;

            let is_valid = vm.validateUploadDocument();
            if (!is_valid) {
                return false;
            }

            if (this.merchant && this.merchant.hasOwnProperty('signatories_upload_documents_flag')
                && this.merchant.signatories_upload_documents_flag === "") {
                this.merchant.signatories_upload_documents_flag = 0;
            }

            let validated = false;
            let url = '/application/ajaxsubmitdocuments';
            let data = {
                "application_external_id": this.merchant.application_external_id,
                "signatories_upload_documents_flag": this.merchant.signatories_upload_documents_flag,
                "application_reference": this.merchant.application_reference,
            };

            let documents_data = this.cleanDocumentData();
            if (!!documents_data && Array.isArray(documents_data) && documents_data.length > 0) {
                data["documents"] = documents_data;
            }

            useModuleStore().commit(types.TOGGLE_LOADING, true);

            let show_success_msg = true;
            return this.getAxiosInstance().post(url, data).then(response => {
                if (response.data.result === 'SUCCESS') {
                    this.merchant.documents = response['data']['document'];
                    //if (to_path) this.nextPage(to_path); //dead lock
                    //else this.nextPage()  //dead lock
                    if (response['data']['pii_masked'] && response['data']['pii_masked_document']) {
                        vm.merchant['pii_masked_document'] = response['data']['pii_masked_document'];
                        vm.merchant['pii_masked'] = response['data']['pii_masked'];
                    }
                    if (vm.isSignerUser) {
                        this.signatory_has_upload_documents = true;
                        if (vm.getSignerDocumentCategories().length <= 0) {
                            show_success_msg = false;
                        }
                    }
                    if (show_success_msg) {
                        this.notifySuccess(this.lang("documents_updated_successfully"));
                    }
                    validated = true;
                }
                return validated;
            });
        },
        askHowSignersUploadDocuments: function() {
            let vm = this;
            if (vm.isSignerUser) {
                return true;
            }

            if (vm.merchant && this.merchant.hasOwnProperty('signatories_upload_documents_flag')
                && vm.merchant.signatories_upload_documents_flag === "") {
                vm.merchant.signatories_upload_documents_flag = 0;
            }

            if (!vm.isSoleTrader && !vm.isSignerUser && vm.multiplePrincipalsCanSign && vm.merchant.signatories_upload_documents_flag !== '1') {
                $('#signatories_id_document_modal').modal('show');
                return false;
            }

            let url = '/application/ajaxsubmitsigneruploaddocuments';
            let data = {
                "application_external_id": vm.merchant.application_external_id,
                "signatories_upload_documents_flag": vm.merchant.signatories_upload_documents_flag,
                "signer_owner_idpal_verification": this.signerOwner.idpal_verification,
            };

            return this.getAxiosInstance().post(url, data).then(response => {
                return true;
            });
        },
        setDefaultCountry: function(document_value) {
            if (document_value.hasOwnProperty('attribute')
                && document_value.attribute.hasOwnProperty('type')
                && document_value.attribute.type === 'country_param') {
                document_value.field_value = this.getAllianceCountryCode(); //alliance country code
            }
        },
        getAllianceCountryCode: function () {
            if (this.parameters && this.parameters.hasOwnProperty('ALLIANCE_PARAM')
                && Array.isArray(this.parameters.ALLIANCE_PARAM) && this.parameters.ALLIANCE_PARAM.length === 1
                && this.parameters.ALLIANCE_PARAM[0].hasOwnProperty('contact_country')) {
                return this.parameters.ALLIANCE_PARAM[0].contact_country;
            }
            return '';
        },
        /*
        Reduce Payload by removing unwanted data such as file Object which has been uploaded already
         */
        cleanDocumentData: function () {
            let documents = [];
            let vm = this;
            this.documents.forEach(document => {
                let uploaded_files = [];
                let clonedDoc = vm.jsonCopy(document);
                clonedDoc.uploaded_files.forEach((file) => {
                    uploaded_files.push({
                        success: file.success,
                        file_name: file.file_name,
                        file_size: file.size,
                        object_id: file.object_id || null,
                        content_type: file.content_type || file.type || null
                    });
                });

                clonedDoc.uploaded_files = uploaded_files;
                documents.push(clonedDoc);
            });

            return documents;
        },
        getStartDate: function (category_id, document, value){
            let document_category = this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'].find(obj => {
                return obj.id === category_id
            })
            if (!!document_category && document_category.category_code === 'PROOF_OF_ID' && document.hasOwnProperty('document_entity_id') && (document.document_entity_id !== '')){
                let selected_owner = this.getEntityList(document.document_entity_id).find(obj => {
                    return obj.id ===  document.selected_entity_id
                })
                if (!!selected_owner){
                    let owner = this.merchant.owners.find(obj => {
                        return obj.owner_ref === selected_owner.id
                    })
                    return !!owner && !!owner.contact_dob ? owner.contact_dob : ''
                }
            }
            return '';
        },
        disallowPast: function(value) {

            const disallowed_past_fields = [
                'expiry_date',
            ];
            return disallowed_past_fields.includes(value.field_name);
        },
        isExpiry: function(value) {
            const disallowed_past_fields = [
                'expiry_date',
            ];
            let resp = disallowed_past_fields.includes(value.field_name)
            return resp
        },
        disallowFuture: function(value) {
            const disallowed_future_fields = [
                'date_of_birth',
                'issued_date'
            ];
            return disallowed_future_fields.includes(value.field_name);
        },
        getEndDate: function (value) {

            const date_of_birth_fields = [
                'date_of_birth',
            ];
            let is_dob = date_of_birth_fields.includes(value.field_name);
            if(is_dob) {
                return  '-18y';
            }else {
                return  this.disallowFuture(value) ? `-1d` : ``;
            }
        },
        getPrettyName: function (file_name) {
            return file_name.replace(/[_-]/g, " ");
        },
        homeRoute: function () {
            this.$router.push({path: `/`});
        },
        formatReviewStatus: function (status) {
            if (status == 2) {
                return '<span class="iconFilter iconGreen addTooltip" data-tooltip-text="Approved" data-original-title="" title=""><i class="flaticon-tick7"></i></span>'
            } else if (status == 3) {
                return '<span class="iconFilter iconRed addTooltip" data-tooltip-text="Not Approved" data-original-title="" title=""><i class="flaticon-cancel1"></i></span>'
            }

            return '';
        },
        isProofOfIDForSigner: function (category_id, is_doc_upload = false) {
            let vm = this;
            if (!!category_id && vm.isSignerUser && vm.signerOwner && vm.signerOwner.hasOwnProperty('owner_ref') && !!vm.signerOwner.owner_ref) {
               if(is_doc_upload){
                   vm.setSignatoryProofOfIdDocumentToUpload();
               }
                let document_category = this.parameters['UPLOAD_DOCUMENT_CATEGORY_PARAM'].find(obj => {
                    return obj.id === category_id;
                });

                let document = !!this.documents ? this.documents.find(doc => {
                    return document_category.hasOwnProperty('category_code') && document_category.category_code == 'PROOF_OF_ID' &&
                           doc.document_category_external_id === document_category.id &&
                           doc.selected_entity_id === vm.signerOwner.owner_ref;
                }) : null;
                return !!document;
            }
            return true;
        },
        getDocumentCategories: function () {
            let vm = this;
            if (vm.isSignerUser) {
                if (vm.isOpenApplication && vm.getDocuments() <= 0) {
                    return [];
                }
                return vm.document_categories.filter(category => {
                    let signer_upload_document_category = vm.getSignerUploadDocumentCategory;
                    let doc_cat = !!signer_upload_document_category ? signer_upload_document_category.find((signer_up_doc_cat) => {
                        return !!category.id && !!signer_up_doc_cat.id && category.id === signer_up_doc_cat.id;
                    }) : null;
                    return category.tenant_udc_external_id && !!doc_cat;
                });
            }
            return vm.document_categories;
        },
        getDocuments: function (from_view_page = false) {
            let vm = this;

            if (vm.isSignerUser && vm.signerOwner && vm.signerOwner.hasOwnProperty('owner_ref') && !!vm.signerOwner.owner_ref) {
                let documents = !!vm.documents ? vm.documents.filter(doc => {
                    // const upload_category = vm.uploadCategory(doc);

                    //const proofIdCategoryCheck = upload_category.hasOwnProperty('category_code') && upload_category.category_code == 'PROOF_OF_ID';
                    const passEntityCheck = doc.selected_entity_id === vm.signerOwner.owner_ref;

                    let signer_upload_document_category = vm.getSignerUploadDocumentCategory;
                    let doc_cat = !!signer_upload_document_category ? signer_upload_document_category.find((signer_up_doc_cat) => {
                        if (!!doc.document_category_external_id && !!signer_up_doc_cat.document_category_external_id &&
                            doc.document_category_external_id == signer_up_doc_cat.document_category_external_id) {
                            return signer_up_doc_cat;
                        }
                    }) : null;
                    const passCategoryCheck = !!doc_cat && doc_cat.document_category_external_id == doc.document_category_external_id;

                    return passCategoryCheck && passEntityCheck;
                }) : [];

                return documents;
            }
            return !!vm.documents ? vm.documents : [];
            // return !from_view_page ? vm.documents : !!vm.documents ? vm.filterDocuments() : [];
        },
        getSignerDocumentCategories: function () {
            let vm = this;
            let signer_document_categories = [];
            if (vm.isSignerUser) {
                signer_document_categories = vm.document_categories.filter(category => {
                    let signer_upload_document_category = vm.getSignerUploadDocumentCategory;
                    let doc_cat = !!signer_upload_document_category ? signer_upload_document_category.find((signer_up_doc_cat) => {
                        return !!category.id && !!signer_up_doc_cat.id && category.id === signer_up_doc_cat.id;
                    }) : null;
                    return category.tenant_udc_external_id && !!doc_cat;
                });
            }
            return signer_document_categories;
        },
        filterDocuments: function () {
            let vm = this;
            return vm.documents.filter(doc => {
                const upload_category = vm.uploadCategory(doc);
                    /*vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')
                    ? vm.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(doc_category => {
                        return doc_category.document_category_external_id === doc.document_category_external_id;
                    }) : [];*/

                if (upload_category.hasOwnProperty('category_code') && upload_category.category_code == 'PROOF_OF_ID') {
                    return doc.selected_entity_id === vm.signerOwner.owner_ref;
                } else {
                    return doc;
                }
            });
        },
        uploadCategory: function (document) {
            let vm = this;
            let result = [];
            if (!!document && vm.parameters.hasOwnProperty('UPLOAD_DOCUMENT_CATEGORY_PARAM')) {
                result = vm.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(doc_category => {
                    return doc_category.document_category_external_id === document.document_category_external_id;
                });
            }
            return result;
        },
        isSignerOwnerDocument: function (document) {
            let vm = this;
            return (!!document && document.hasOwnProperty('selected_entity_id') && vm.signerOwner && document.selected_entity_id === vm.signerOwner.owner_ref);
        },
        hasProofOfID: function () {
            let vm = this;

            let signer_required_upload_category = vm.getSignerUploadDocumentCategory;
            let identifiedSignatory = !!vm.documents ? vm.documents.filter(doc => {
                let doc_cat = !!signer_required_upload_category ? signer_required_upload_category.find((signer_up_doc_cat) => {
                    if (!!doc.document_category_external_id && !!signer_up_doc_cat.document_category_external_id &&
                        doc.document_category_external_id == signer_up_doc_cat.document_category_external_id) {
                        return signer_up_doc_cat;
                    }
                }) : null;
                const is_document_selected = doc.selected == '1';
                const is_document_for_logged_signer = doc.selected_entity_id === vm.signerOwner.owner_ref;
                const is_document_required_for_signer = !!doc_cat && doc_cat.document_category_external_id == doc.document_category_external_id;

                if (is_document_selected && is_document_for_logged_signer && is_document_required_for_signer) {
                    return doc;
                }
            }) : null;

            const has_ekyc_set = (vm.ekycAllowedByWorkflow && !!vm.signerOwner.ekyc_verification && vm.signerOwner.ekyc_verification == '1');
            const has_idpal_set = (vm.isIdPalWorkflowConfigured && vm.signerOwner.idpal_verification && vm.signerOwner.idpal_verification == '1');
            const has_bankid_set = (vm.canUseBankIdVerify && vm.signerOwner.is_bank_id_verified && vm.signerOwner.is_bank_id_verified == '1');
            const has_upload_document = (Array.isArray(identifiedSignatory) && identifiedSignatory.length > 0);
            return (has_ekyc_set || has_idpal_set || has_bankid_set || has_upload_document)
        },
        signerHasUploadedFiles: function () {
            let vm = this;

            let signer_required_upload_category = vm.getSignerUploadDocumentCategory;
            let identifiedSignatory = !!vm.documents ? vm.documents.filter(doc => {
                let doc_cat = !!signer_required_upload_category ? signer_required_upload_category.find((signer_up_doc_cat) => {
                    if (!!doc.document_category_external_id && !!signer_up_doc_cat.document_category_external_id &&
                        doc.document_category_external_id == signer_up_doc_cat.document_category_external_id) {
                        return signer_up_doc_cat;
                    }
                }) : null;
                const is_document_selected = doc.selected == '1';
                const is_document_for_logged_signer = doc.selected_entity_id === vm.signerOwner.owner_ref;
                const is_document_required_for_signer = !!doc_cat && doc_cat.document_category_external_id == doc.document_category_external_id;

                if (is_document_selected && is_document_for_logged_signer && is_document_required_for_signer) {
                    return doc;
                }
            }) : null;

            const has_upload_document = (Array.isArray(identifiedSignatory) && identifiedSignatory.length > 0);
            if (has_upload_document) {
                return vm.documentsHaveUploadedFiles(identifiedSignatory);
            }
            return false;
        },
    },
    watch: {
        'merchant.documents': {
            immediate: true,
            handler: function(val) {
                let vm = this;
                if (!!val){
                    let valid_tenant_categories = (!!vm.parameters && vm.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM')) ?
                        vm.parameters['TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];
                    let configured_document_types = (!!vm.parameters && vm.parameters.hasOwnProperty('TENANT_DOCUMENT_METADATA_PARAM')) ?
                        vm.parameters['TENANT_DOCUMENT_METADATA_PARAM'] : [];

                    let has_valid_tenant_categories = Array.isArray(valid_tenant_categories) &&
                        valid_tenant_categories.length > 0;

                    let has_configured_document_types = Array.isArray(configured_document_types) &&
                        configured_document_types.length > 0;

                    const documentWithValidCategory = (document) => {
                        if (has_valid_tenant_categories) {
                            let field1 = 'document_category_external_id';
                            let field2 = 'tenant_udc_external_id';
                            let tenant_category =  valid_tenant_categories.find(category => {
                                return category[field1] === document[field1] && category[field2] === document[field2]
                            });

                            if (tenant_category) {
                                return true;
                            }
                        }

                        return false;
                    };

                    let selected_categories = [];

                    let mapped_documents = [];

                    if (has_configured_document_types) {
                        configured_document_types.forEach(obj => {
                            // map already submitted document if it exists
                            const submitted_document_types = val.filter((doc) => {
                                return (doc.tenant_upload_document_type_external_id == obj.tenant_upload_document_type_external_id
                                    && doc.tenant_udc_external_id == obj.tenant_udc_external_id)
                            });



                            if (submitted_document_types.length > 0) {
                                submitted_document_types.forEach(doc => {
                                    //always reset the document variable
                                    let document = new Document(obj);
                                    let document_has_valid_category = documentWithValidCategory(document);

                                    document.selected = '1';
                                    document.document_external_id = doc.document_external_id;
                                    selected_categories.push(document.document_category_external_id);

                                    // Set Document Values Details
                                    if (!!doc.values) {
                                        document.values.map(value => {
                                            doc.values.forEach(submitted_value => {
                                                if (submitted_value.field_name == value.field_name) {
                                                    value.field_value = submitted_value.field_value;
                                                    vm.setDefaultCountry(submitted_value);
                                                }
                                            });
                                        });
                                    }

                                    // Set Document Entity Details
                                    if (!!doc.entity_id && doc.entity_id != '') {
                                        document.selected_entity_id = doc.entity_id;
                                    }
                                    if (!!document.document_entity_id && document.document_entity_id != '') {
                                        vm.setDocumentEntity(document);
                                    }

                                    // Set Document File Details
                                    let doc_files = doc.files ?? [];
                                    // .forEach breaks if doc.files is not an array
                                    doc_files.forEach(file => {
                                        const file_data = {
                                            name: vm.getPrettyName(file.file_name),
                                            file_name: file.file_name,
                                            success: true,
                                            id: file.file_name,
                                            size: file.file_size,
                                            object_id: file.object_id ?? null,
                                            content_type: file.content_type ?? null
                                        };

                                        document.uploaded_files.push(file_data);
                                    });

                                    if (document_has_valid_category) {
                                        mapped_documents.push(document);
                                    }

                                });
                            } else {
                                //always reset the document variable
                                let document = new Document(obj);
                                let document_has_valid_category = documentWithValidCategory(document);

                                document.values.forEach(document_value => {
                                    vm.setDefaultCountry(document_value);
                                });

                                // Set Document Entity Details
                                if (!!document.document_entity_id && document.document_entity_id != '') {
                                    vm.setDocumentEntity(document);
                                }

                                if (document_has_valid_category) {
                                    mapped_documents.push(document);
                                }
                            }
                        });
                    }
                    //vm.documents = mapped_documents;
                    useApplicationStore()[types.SET_DOCUMENTS_INSTANCE] (mapped_documents);
                    //useApplicationStore().commit(types.SET_DOCUMENTS_INSTANCE, mapped_documents);
                    //vm.$store.commit(types.SET_APPLICATION_MODULE + types.SET_DOCUMENTS_INSTANCE, mapped_documents);

                    let document_categories = configured_document_types.reduce((categories, tenant_meta_data) => {
                        let category_loaded = categories.find((category) => {
                            return category.id === tenant_meta_data.document_category_external_id
                        });
                        if (!category_loaded) {
                            //console.log('category', vm.parDocumentCategories);
                            let categoryParam = vm.parDocumentCategories.find(categoryObj => {
                                let field = 'document_category_external_id';
                                return categoryObj[field] === tenant_meta_data[field];
                            });

                            let tenant_upload_category_param = this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                                this.parameters['TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM'] : [];

                            let has_tenant_upload_category_param = Array.isArray(tenant_upload_category_param) &&
                                tenant_upload_category_param.length > 0;

                            let tenantCategoryObj = has_tenant_upload_category_param ?
                                tenant_upload_category_param.find(tenant_category => {
                                    let field = 'tenant_udc_external_id';
                                    return tenant_category[field] === tenant_meta_data[field];
                                }) : undefined;

                            let priority_order = categoryParam && categoryParam.hasOwnProperty('priority_order') &&
                            parseInt(categoryParam.priority_order) > 0 ?
                                categoryParam.priority_order :
                                '0';

                            //console.log('priority_order', priority_order, categoryParam, tenant_meta_data)

                            let payload = {
                                id: tenant_meta_data.document_category_external_id,
                                selected: selected_categories.includes(tenant_meta_data.document_category_external_id),
                                document_reference: tenant_meta_data.document_reference,
                                category_code: categoryParam ? categoryParam.category_code: undefined,
                                tenant_udc_external_id: tenant_meta_data.tenant_udc_external_id,
                                priority_order: priority_order
                            };

                            if (tenantCategoryObj) {
                                //console.log('tenantCategoryObj', tenantCategoryObj);
                                payload.is_required = tenantCategoryObj.is_required;
                                categories.push(payload);
                            }
                        }

                        return categories;
                    }, []);

                    vm.document_categories = vm.orderedDocumentCategories(document_categories);
                }
            }
        },
        'signerOwner': {
            immediate: true,
            handler: function(val) {
                let vm = this;
                // console.log('signerOwner :=>', vm.signerOwner);
                if (vm.signerOwner && vm.signerOwner.hasOwnProperty('ekyc_verification')) {
                    vm.ekyc_verification = vm.signerOwner.ekyc_verification;
                }
                vm.setShowIdPalSection();
            }
        }
    }
}